export default __webpack_public_path__ + "static/careers-available-jobs-second-glow-baba0ff4747939e6ad00243f115dd670.svg";